/**
 * Global JS variables
 */
window.sarypak = {
    breakpoints: {
        sm: 576,
        md: 768,
        lg: 991,
        xl: 1280
    },
    
    PHPToJS: {
        currentPage: $('body').data('current-page') ?? false,
        userInfos: {
            email: $('#data-email--user-infos').attr('data-value'),
            isPro: parseInt($('#data-is-pro--user-infos').attr('data-value')) === 1
        },
        public: {
            albumID: $('#data-public-album-id').attr('data-value') ?? false,
            albumDirectItemID: $('#data-public-album-direct-item-id').attr('data-value') ?? false
        },
        dashboard: {
            albumID: $('#data-dashboard-album-id').attr('data-value') ?? false,
            albumType: $('#data-dashboard-album-type').attr('data-value') ?? false
        }, 
        routes: {
            currentName: $('#data-current-name--route').attr('data-value'),
            homepage: $('#data-homepage--route').attr('data-value'),
            accountPortfolio: $('#data-account-portfolio--route').attr('data-value'),
            login: $('#data-login--route').attr('data-value'),
            announcements: $('#data-announcements--route').attr('data-value'),
            keywordSearch: $('#data-keyword-search--route').attr('data-value'),
            error404: $('#data-error-404--route').attr('data-value')
        }
    }
};

/**
 * AJAX CSRF token
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});